import { Skeleton } from 'antd'
import { ScrollBar } from 'components/CommonStyles'
import SearchInput from 'components/SearchInput'
import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'
import { getCities } from 'modules/Roles/actions'
import React, { useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'

const Wrapper = styled.div`
  padding: 1rem 0.5rem;
`
const SkillFilter = ({ setLocation, setSkill, value }) => {
  const dispatch = useDispatch()
  const citiesList = useSelector(state => state?.roles.cities)
  const [citiesData, setCitiesData] = useState([])
  const [pageNum, setPageNum] = useState(1)
  const [search, setSearch] = useState('')
  const [debounced, setDebounced] = useState(() => search)
  useEffect(() => {
    dispatch(getCities())
  }, [])
  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setDebounced(search)
    }, 1000)
    return () => {
      clearTimeout(timeout)
    }
  }, [search])

  React.useEffect(() => {
    if (search) {
      setCitiesData([])
      dispatch(getCities(`currentPage=0&search=${search}`))
    }
    setPageNum(1)
  }, [debounced])

  useEffect(() => {
    if (citiesList?.length) {
      let list = citiesList
        ?.map(val => {
          return {
            label: val?.name,
            value: val?.name,
          }
        })
        .filter(option => option?.label)

      let newList = [...citiesData, ...list]
      setCitiesData(newList)
      setPageNum(prev => prev + 1)
    }
  }, [citiesList])

  const onChange = checkedvalue => {
    let locationVal = [...value]
    if (checkedvalue.length) {
      setLocation([...value, ...checkedvalue])
    } else {
      let commonData = citiesData.filter(({ value }) =>
        locationVal.includes(value)
      )
      let i = locationVal.findIndex(val => commonData[0].value == val)
      locationVal.splice(i, 1)
      setLocation(locationVal)
    }
  }
  const loadMore = () => {
    if (search) {
      dispatch(getCities(`currentPage=${pageNum}&search=${search}`))
    } else {
      dispatch(getCities(`currentPage=${pageNum}`))
    }
  }
  return (
    <Wrapper>
      <SearchInput
        width={'90%'}
        placeholder="Search by keyword"
        bordered={true}
        setSearchValue={e => {
          setSearch(e)
        }}
      />

      <ScrollBar id="scrollableDiv" height={'28vh'}>
        <InfiniteScroll
          dataLength={citiesData?.length}
          next={loadMore}
          hasMore={citiesList?.totalPages > pageNum}
          loader={<Skeleton paragraph={{ rows: 1 }} active />}
          scrollableTarget="scrollableDiv"
        >
          <FilterCheckBoxComp
            options={citiesData}
            value={value}
            onChange={onChange}
          />
        </InfiniteScroll>
      </ScrollBar>
    </Wrapper>
  )
}

export default SkillFilter
